import React, { useEffect, useState } from 'react';
import { userApi } from '../../services/api';
import { LegalDocument } from '../../types';

function formatUpdated(doc: LegalDocument | null): string {
  const raw = doc?.dateUpdated || doc?.dateCreated;
  if (!raw) return '';
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'long', year: 'numeric' });
}

const TermsOfServicePage: React.FC = () => {
  const [doc, setDoc] = useState<LegalDocument | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    userApi.getCurrentLegalDocuments()
      .then((r) => {
        if (!cancelled) setDoc(r.data.terms ?? null);
      })
      .catch(() => {
        if (!cancelled) setError('Unable to load Terms of Service.');
      });
    return () => { cancelled = true; };
  }, []);

  const updated = formatUpdated(doc);

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <div className="surface-card p-6 sm:p-10 prose prose-gray max-w-none">
      <h1>{doc?.title || 'Terms & Conditions'}</h1>
      {(updated || doc?.version) && (
        <p className="text-sm text-gray-500">
          {updated ? `Last updated: ${updated}` : null}
          {updated && doc?.version ? ' · ' : null}
          {doc?.version ? `Version ${doc.version}` : null}
        </p>
      )}
      {error && <p className="text-error-600">{error}</p>}
      {!error && !doc && <p className="text-gray-500">Loading…</p>}
      {doc?.bodyHtml && (
        <div dangerouslySetInnerHTML={{ __html: doc.bodyHtml }} />
      )}
      </div>
    </div>
  );
};

export default TermsOfServicePage;
